import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailStep} from '../interfaces/icruise-detail-step';

@Pipe({
  name: 'cruiseStepMarkers'
})
export class CruiseStepMarkersPipe implements PipeTransform {
  transform(value: ICruiseDetailStep[]): {lat: number, lng: number, label: string}[] {
    if(value) {
      return value.filter(e => !e.isNavigation).flatMap(e => e.harbours.map(
        harb => ({ lat: parseFloat(harb.data.Lt), lng: parseFloat(harb.data.Ll), label: e.day.toString() })
      ));
    }

    return [];
  }
}
